import { useContext } from 'react';

import { UserContext } from '@/auth/user-context-provider';
import { APPSMITH_APP_URL } from '@/constants/environment';

export function IframeContainer() {
  const { jwt } = useContext(UserContext);

  return (
    <div
      style={{ border: '1px solid #ccc', padding: '10px', borderRadius: '8px' }}
    >
      <iframe
        src={`${APPSMITH_APP_URL}?embed=true&jwt=${jwt}`}
        title="HSM Admin"
        style={{
          width: '100%',
          height: '100vh', // Ajusta la altura según lo que necesites
          border: 'none', // Elimina el borde del iframe
        }}
        allowFullScreen
      ></iframe>
    </div>
  );
}
